module.exports = __webpack_public_path__ + "static/media/epic-icon.103cdc86.png";